const baseURL = "/v1/Funcao/Funcao";

const service = {
  methods: {
    $buscarFuncoes(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarFuncoes({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarFuncao(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarFuncao(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarFuncao(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
